// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"115d83b9","246":"52ef1166","275":"46cfbd7b","361":"10f04c0c","368":"3f6c18d1","395":"a49ea0d4","460":"a993298a","517":"1860e45c","636":"0c1b2907","665":"fc8b3716","863":"cae6cd83","896":"ee363dd7","988":"82720922"}[chunkId] + ".chunk.js";
};